/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IMealSchedule } from 'app/shared/model/meal-schedule.model';
import { IRecipe } from 'app/shared/model/recipe.model';

export interface IMealDetails {
  id?: string;
  active?: boolean;
  timestampentry?: number;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  glucoUser?: IGlucoUser;
  mealDetailsSchedule?: IMealSchedule;
  recipeMealDetails?: IRecipe;
}

export const defaultValue: Readonly<IMealDetails> = {
  active: false,
};
